import './NoGrantsView.scss';

import NoGrantsView from './NoGrantsView';

export default NoGrantsView;
